import { render, staticRenderFns } from "./select-instance-modal.component.vue?vue&type=template&id=ba2a2020&scoped=true&"
import script from "./select-instance-modal.component.vue?vue&type=script&lang=ts&"
export * from "./select-instance-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./select-instance-modal.component.vue?vue&type=style&index=0&id=ba2a2020&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2a2020",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
